import { Component, ComponentRef, EventEmitter, Input, Output, ViewChild, ViewContainerRef } from '@angular/core';
import { TableLazyLoadEvent } from 'primeng/table';
import { PatientService } from '../../../pages/definition/patient/services/patient.service';
import { OverlayPanel } from 'primeng/overlaypanel';
import { PatientCreateComponent } from '../../../pages/definition/patient/patient-create/patient-create.component';
import { IPatient } from '../../../pages/definition/patient/interface/patient.interface';

@Component({
  selector: 'app-patient-card',
  templateUrl: './patient-card.component.html',
  styleUrl: './patient-card.component.scss',
})
export class PatientCardComponent {
  @ViewChild('patientCreate', { read: ViewContainerRef }) patientCreate!: ViewContainerRef;
  private patientComponentRef?: ComponentRef<PatientCreateComponent>; 

  @ViewChild('op') op: OverlayPanel;
  @Output() selectOn = new EventEmitter();
  @Output() openDetailOn = new EventEmitter<any>();
  @Input() disabledInfoButton:boolean=false
  @Input() delete?:boolean = false; 
  isOpen: boolean = false;
  // isOpenDetail:boolean=false;
  isFirtsTime:boolean=true;
  filters = {
    tckn: '',
    passportNo: '',
    name: '',
    surname: '',
    gender: '',
    birthDate: null,
    phone: '',
  };

  first: number = 0;
  rows: number = 10;
  totalRecords: number = 0;
  loading: boolean = false;
  genders: { label: string; value: string }[] = [
    { label: 'Erkek', value: 'Male' },
    { label: 'Kadın', value: 'Female' },
  ];
  patients: any = [];
  selectedPatient: any = null;
  savedPatientId:any=null
  @Input() isApproved:boolean=false
  constructor(private readonly patientService: PatientService,
  ) {}



  async loadData(event: TableLazyLoadEvent) {
    this.isFirtsTime=false;
    const page = Math.floor(event.first! / event.rows!) + 1;
    this.totalRecords = 0;
    this.loading = true;
    const filterObj = {
      firstName: this.filters.name,
      lastName: this.filters.surname,
      idNumber: this.filters.tckn,
      passportNo: this.filters.passportNo,
      phone: this.filters.phone,
      gender: this.filters.gender,
      birthDate: this.filters.birthDate
        ? this.formatDate(this.filters.birthDate)
        : '',
    };

    this.patientService.getPatients(filterObj, page, event.rows!).subscribe({
      next: (data) => {
        this.patients = data.items;
        this.totalRecords = data.total;
        this.loading = false;
      },
      error: (error) => {
        this.loading = false;
      },
    });
  }

  formatDate(date: Date): string {
    date.setHours(12, 0, 0, 0); // Tarihi 12:00'ye ayarla ki UTC farkı kayma yapmasın
    return date.toISOString().split('T')[0]; // YYYY-MM-DD olarak dön
  }

  clearFilters() {
    this.filters = {
      tckn: '',
      passportNo: '',
      name: '',
      surname: '',
      gender: '',
      birthDate: null,
      phone: '',
    };
    this.first = 0;
    this.loadData({ first: 0, rows: this.rows });
  }

  clearFilter() {
    this.filters = {
      tckn: '',
      passportNo: '',
      name: '',
      surname: '',
      gender: '',
      birthDate: null,
      phone: '',
    };
    this.patients=[];
    this.totalRecords=0;
    this.isFirtsTime=true;
  }

  confirmSelection() {
    if (this.selectedPatient) {
      this.selectOn.emit(this.selectedPatient);
      this.isOpen = false;
    }
  }

  clearSearch() {
    this.resetSelectedPatient()
    this.selectOn.emit(this.selectedPatient);
  }

  resetSelectedPatient(){
    this.selectedPatient=null;
    this.savedPatientId=null;
  }

  search() {
    this.isOpen = true;
  }

  setPatientValue(id:number){
    this.savedPatientId=id;
  }

  showDetails() {
    this.patientService.getFilter({},{
     'filter.id':this.selectedPatient?.id ?? this.savedPatientId,
    }).subscribe({
      next:(res)=>{
        const obj=res?.items?.length>0 ? res?.items[0]:null;
        if(obj){
          this.openDetailOn.emit(obj)
        }
      }
    })
  }

  private getPatientId(p: any): number | null {
    const id = p?.id ?? p?._id ?? null;
    return id != null ? Number(id) : null;
  }


  createPatient() {
    if (!this.patientComponentRef) {
      this.patientComponentRef = this.patientCreate.createComponent(PatientCreateComponent);
    }
    this.patientComponentRef.instance.openOffcanvas();
    this.patientComponentRef.instance.saved.subscribe(async (newPatient: any) => {
      const pid = this.getPatientId(newPatient);
      this.savedPatientId = pid;
      this.selectedPatient = newPatient;
      if (newPatient && typeof newPatient === 'object' && Object.keys(newPatient).length > 1) {
        this.confirmSelection();
        return;
      }

      if (pid) {
        this.patientService.getFilter({}, { 'filter.id': pid }).subscribe({
          next: (res) => {
            const obj = res?.items?.length > 0 ? res.items[0] : null;
            if (obj) {
              this.selectedPatient = obj;
            }
            this.confirmSelection();
          },
          error: () => {
            this.confirmSelection();
          }
        });
      } else {
        this.confirmSelection();
      }
    });

  }
  
  clearPatient(emit: boolean = false): void {
    this.selectedPatient = null;
    this.savedPatientId = null;

    this.patients = [];
    this.totalRecords = 0;
    this.first = 0;
    this.loading = false;
    this.isOpen = false;
    this.isFirtsTime = true;

    this.filters = {
      tckn: '',
      passportNo: '',
      name: '',
      surname: '',
      gender: '',
      birthDate: null,
      phone: '',
    };

    if (emit) {
      this.selectOn.emit(null);
    }
  }

}
